import { type FC } from 'react';
import { FormField, MaskedTextInputCompact, Text, usePriceMask } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { useField, useFormInstance } from '@adv-frontend/form-kit';
import { MAX_AVAILABLE_PRICE, MIN_AVAILABLE_PRICE, RUBBLE_SIGN } from '../../../../lib/constants';
import { useFormFieldErrorProps } from '../../../../lib/form';
import { changeVariantPriceFieldGetErrorMessage, changeVariantPriceTooltipForm } from '../../model';
import { useIsMinimalPriceGreaterThanPrice } from '../../model/hooks/useIsMinimalPriceGreaterThanPrice';

type PriceFieldProps = { formId: string; isSaving: boolean } & TestProps;

export const PriceField: FC<PriceFieldProps> = ({ formId, 'data-testid': dataTestId = 'PriceField', isSaving }) => {
    const formInstance = useFormInstance({ form: changeVariantPriceTooltipForm, id: formId });

    const field = useField(formInstance.fields.price);
    const fieldProps = field.getProps();
    const errorProps = useFormFieldErrorProps(field.state, changeVariantPriceFieldGetErrorMessage);

    const priceMaskConfig = usePriceMask({
        currencyText: RUBBLE_SIGN,
        min: MIN_AVAILABLE_PRICE,
        max: MAX_AVAILABLE_PRICE,
        precision: 0,
    });
    const isMinimalPriceGreaterThanPrice = useIsMinimalPriceGreaterThanPrice(formId);

    return (
        <div>
            <FormField
                {...errorProps}
                data-testid={dataTestId}
                description={
                    isMinimalPriceGreaterThanPrice ? (
                        <Text color="orange" data-testid={`${dataTestId}.Description`}>
                            Цена ниже, чем минимальная цена
                        </Text>
                    ) : undefined
                }
            >
                {(formFields) => (
                    <MaskedTextInputCompact
                        {...formFields}
                        {...fieldProps}
                        maskConfig={priceMaskConfig}
                        isLoading={isSaving}
                        min={MIN_AVAILABLE_PRICE}
                        max={MAX_AVAILABLE_PRICE}
                        label="Цена до скидки"
                        data-testid={`${dataTestId}.TextInput`}
                        size="xs"
                    />
                )}
            </FormField>
        </div>
    );
};
